export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4678.e03e258a.jpg";